/* global change_password_ajax_url */
/* global ajax_nonce */

export default {
  init() {
    changePassword();
  },
};

export var changePassword = () => {
$( 'form[name="changepassword"]' ).on( 'submit', function(e) {
  e.preventDefault();
  var form_data = $( this ).serializeArray();
  form_data.push( { 'name' : 'security', 'value' : ajax_nonce } );

  $.ajax({
      url : change_password_ajax_url.ajax_url, // Here goes the AJAX endpoint.
      type : 'post',
      data : form_data,
      success : function( response ) {
        let type = 'woocommerce-error';
        if (response.success){
          type = 'woocommerce-message';
        }
        let messageClass = $('.'+type)
        if (messageClass[0]) {
          messageClass.append('<li>' + response.data + '</li>');
        }else {
          $('.woocommerce-notices-wrapper').append('<ul class="' + type + '" role="alert"><li>' + response.data + '</li></ul>');
        }
      },
  });
  return false;
});
};
